import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import useDeleteStream from 'hooks/API/DELETE/useDeleteStream';
import useToaster from 'hooks/useToaster';

function StreamDeleteModal({ modalConfig = {}, closeModal }) {
  const { mutate, isLoading, isError } = useDeleteStream();
  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function deleteStream() {
    mutate(modalConfig.data ?? {});
    closeModal();
  }

  return (
    <AppModal open={modalConfig.show} closeModal={closeModal} size="md" centered>
      <AppModalHeader>Delete Stream</AppModalHeader>
      <AppModalBody>
        <p className="modal-sub-text text-center">Are you sure you want to delete this stream?</p>

        <div className="app-l-modal-btn-block">
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={deleteStream}>
            YES<sup>*</sup>
          </AppButton>
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={closeModal}>
            NO
          </AppButton>
        </div>

        <p className="modal-sub-note">
          <sup>*</sup>Please note that this action is irreversible
        </p>
      </AppModalBody>
    </AppModal>
  );
}

export default StreamDeleteModal;
